export type Role = {
	id: number;
	name: string;
	description: string;
	type: string;
};
